import {FormikSelect} from '@flexinet/ui-components';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';

const currencyOptions = [
    {value: 'usd', label: 'USD - US Dollar'},
    {value: 'eur', label: 'EUR - Euro'},
    {value: 'gbp', label: 'GBP - British Pound'},
    {value: 'cad', label: 'CAD - Canadian Dollar'},
    {value: 'aud', label: 'AUD - Australian Dollar'},
    {value: 'jpy', label: 'JPY - Japanese Yen'},
    {value: 'chf', label: 'CHF - Swiss Franc'},
    {value: 'inr', label: 'INR - Indian Rupee'},
    {value: 'brl', label: 'BRL - Brazilian Real'},
    {value: 'mxn', label: 'MXN - Mexican Peso'},
];

export const CurrencyDropdown = (props: FieldProps & SelectProps) => {
    return <FormikSelect {...props} data={currencyOptions} clearable/>;
};
